export default "__VITE_ASSET__Cl9RECDe__"